import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "react-tabulator/lib/styles.css"; // required styles
import "react-tabulator/lib/css/tabulator.min.css"; // theme
import "./styles/theme-components.css";
import "./styles/responsive.css"; // P8.2 — Responsive Design (must be last)


import { useEffect, useState } from "react";
import { ThemeProvider } from "./contexts/ThemeContext";
import { Route, Switch, BrowserRouter, Redirect } from "react-router-dom";
import Login from "./pages/Login";
import Home from "./pages/Home";
import Header from "./pages/Header";
import { UserProvider, useSession } from "./firebase/UserProvider";
import PageRoute from "./route/PageRoute";
import Default from "./pages/Default";
import TestPage from "./pages/TestPage";
import { UserPrivilageProvider } from "./firebase/UserPrivilageProvider";
import PrivateDMSRoute from "./route/PrivateDMSRoute";

import SearchDonor from "./pages/SearchDonor";
import DonorDetails from "./pages/DonorDetails";
import AcceptDonation from "./pages/AcceptDonation";
import Sidebar from "./pages/Sidebar";
import AddANewDonor from "./pages/AddANewDonor";
import PrivateAdminRoute from "./route/PrivateAdminRoute";
import SearchUser from "./pages/SearchUser";
import UserDetails from "./pages/UserDetails";
import TaskRouteGuard from "./components/TaskRouteGuard";
import TaskListPage from "./pages/tms/TasksDashboard";
import CreateTaskPage from "./pages/tms/CreateTask";
import TaskDetailPage from "./pages/tms/TaskDetail";
import EditTaskPage from "./pages/tms/EditTask";
import AdminDashboardPage from "./pages/tms/AdminDashboard";
import TasksByUserPage from "./pages/tms/TasksByUser";
import TasksByStatePage from "./pages/tms/TasksByState";
import { TasksByLabel } from "./pages/tms/TasksByLabel";
import LabelFilterViewPage from "./pages/tms/LabelFilterView";
import LabelSearchPage from "./pages/tms/LabelSearchPage";
import { LabelsReport } from "./pages/tms/LabelsReport";
import TasksRaisedByMePage from "./pages/tms/TasksRaisedByMe";
import TasksPendingMePage from "./pages/tms/TasksPendingMe";
import TeamWorkloadReportPage from "./pages/tms/TeamWorkloadReport";
import Footer from "./pages/Footer";
import PrivateDMSReportsRoute from "./route/PrivateDMSReportsRoute";
import DonorReportHome from "./pages/donation-reports/DonorReportHome";
import DateRangeDonationReport from "./pages/donation-reports/DateRangeDonationReport";
import AddCommitment from "./pages/AddCommitment";
import EditCommitment from "./pages/EditCommitment";
import SearchDonorByName from "./pages/SearchDonorByName";
import AllDonorDetailReport from "./pages/donation-reports/AllDonorDetailReport";
import MissedCommittmentReport from "./pages/donation-reports/MissedCommittmentReport";
import { firestore } from "./firebase/config";
import Form10BDReport from "./pages/donation-reports/Form10BDReport";
import { collection, query, where, onSnapshot } from "firebase/firestore";
function App() {
  /* const [isParentPortal, setIsParentPortal] = useState(false); */
  const [userInfo, setUserInfo] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showMaintenenceMessage, setShowMaintenenceMessage] = useState(false);
  const [maintenenceMessage, setMaintenenceMessage] = useState("");
  // const [windowDimensions, setWindowDimensions] = useState({
  //   height: window.innerHeight,
  //   width: window.innerWidth,
  // });
  // const handleWindowResize = () => {
  //   setWindowDimensions({
  //     height: window.innerHeight,
  //     width: window.innerWidth,
  //   });
  // };
 // window.addEventListener("resize", handleWindowResize);
  const user = useSession();

  useEffect(() => {
    if (user && !user.loading) {
      setUserInfo(user.user);
    }
  }, [user]);

  useEffect(() => {
    const q = query(
      collection(firestore, "system-preferences"),
      where("name", "==", "showMaintenanceMessage")
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      if (!snapshot.empty) {
        let value = snapshot.docs[0].data().value;
        let message = snapshot.docs[0].data().message;

        setShowMaintenenceMessage(value);
        setMaintenenceMessage(message);
      }
    });

    // Cleanup function
    return () => unsubscribe();
  }, []);

  const appClass = ""; /* `${isParentPortal ? "app-div" : ""}`; */
  const mainContentClass = ""; /* `${isParentPortal ? "main-content-div" : ""}`; */
  const alignContent = ""; /* `${isParentPortal ? "alignContent" : ""}`; */

  return (
    <>
      {showMaintenenceMessage ? (
        <>
          <h2>
            <div className="text-danger">{maintenenceMessage}</div>
          </h2>
        </>
      ) : (
        <>
          <ThemeProvider>
          <UserProvider>
            <UserPrivilageProvider>
              <BrowserRouter>
                <div id="app" className={appClass}>
                  <div id="main-content" className={mainContentClass}>
                    <Header
                      sidebarOpen={sidebarOpen}
                      onSidebarToggle={() => setSidebarOpen((o) => !o)}
                    />
                    <div className={alignContent}>
                      <div
                        className={
                          userInfo ? `float-right main` : `switchContent`
                        }
                      >
                        {/* {isParentPortal && (
                          <div className="row rectangle d-flex flex-nowrap justify-content-start justify-content-md-end resetMargin ml-2 mr-2">
                            <div className="p-2">
                              <div>
                                <h3>
                                  {windowDimensions.width > 768
                                    ? "Bhaktivedanta Model School"
                                    : "BMS"}
                                </h3>
                              </div>
                            </div>
                            <div className="w-100">
                              <div></div>
                            </div>

                            <div className="p-2">
                              <div>
                                <h3>{"Jharokha"}</h3>
                              </div>
                            </div>
                          </div>
                        )} */}
                        <div>
                          <Sidebar
                            isOpen={sidebarOpen}
                            onClose={() => setSidebarOpen(false)}
                          />
                          <Switch>
                            <PageRoute exact path="/home" component={Home} />
                            <PrivateDMSRoute
                              exact
                              path="/test"
                              component={TestPage}
                            />
                            <PrivateDMSRoute
                              exact
                              path="/donorsearch"
                              component={SearchDonor}
                            />
                            <PrivateDMSRoute
                              exact
                              path="/donorsearchbyname"
                              component={SearchDonorByName}
                            />
                            <PrivateDMSRoute
                              exact
                              path="/alldonordetailreport"
                              component={AllDonorDetailReport}
                            />
                            <PrivateDMSRoute
                              exact
                              path="/addnewdonor"
                              component={AddANewDonor}
                            />
                            <PrivateDMSRoute
                              exact
                              path="/donordetails/:donorId"
                              component={DonorDetails}
                            />
                            <PrivateDMSRoute
                              exact
                              path="/acceptdonation/:type/:donorId"
                              component={AcceptDonation}
                            />
                            <PrivateDMSRoute
                              exact
                              path="/addcommitment/:donorId"
                              component={AddCommitment}
                            />
                            <PrivateDMSRoute
                              exact
                              path="/editcommitment/:donorId/:commitmentId"
                              component={EditCommitment}
                            />
                            <PrivateAdminRoute
                              exact
                              path="/searchuser"
                              component={SearchUser}
                            />
                            <PrivateAdminRoute
                              exact
                              path="/userdetails/:userId"
                              component={UserDetails}
                            />

                            <PrivateDMSReportsRoute
                              exact
                              path="/donorreporthome"
                              component={DonorReportHome}
                            />
                            <PrivateDMSReportsRoute
                              exact
                              path="/donationdaterangereport"
                              component={DateRangeDonationReport}
                            />
                            <PrivateDMSReportsRoute
                              exact
                              path="/missedcommittmentreport"
                              component={MissedCommittmentReport}
                            />
                            <PrivateDMSReportsRoute
                              exact
                              path="/form10bdreport"
                              component={Form10BDReport}
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks"
                              component={TaskListPage}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/new"
                              component={CreateTaskPage}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/dashboard"
                              component={AdminDashboardPage}
                              requiredRole="taskAdmin"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/reports/by-user"
                              component={TasksByUserPage}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/reports/by-state"
                              component={TasksByStatePage}
                              requiredRole="taskUser"
                            />
                             <TaskRouteGuard
                              exact
                              path="/tasks/reports/by-label"
                              component={TasksByLabel}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/reports/labels"
                              component={LabelsReport}
                              requiredRole="taskAdmin"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/labels/search"
                              component={LabelSearchPage}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/label/:labelName"
                              component={LabelFilterViewPage}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/reports/raised-by-me"
                              component={TasksRaisedByMePage}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/reports/pending-me"
                              component={TasksPendingMePage}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/reports/team-workload"
                              component={TeamWorkloadReportPage}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/:taskNumber/edit"
                              component={EditTaskPage}
                              requiredRole="taskUser"
                            />
                            <TaskRouteGuard
                              exact
                              path="/tasks/:taskNumber"
                              component={TaskDetailPage}
                              requiredRole="taskUser"
                            />
                            <Route exact path="/login" component={Login} />
                            <Route exact path="/">
                              <Redirect to="/login" />
                            </Route>
                            {/* <Route
                              exact
                              path="/academiccalendar/:section"
                              component={AcademicCalendar}
                            /> */}
                            <Default notfound />
                          </Switch>
                        </div>
                      </div>
                    </div>
                    <Footer />
                  </div>
                </div>
              </BrowserRouter>
            </UserPrivilageProvider>
          </UserProvider>
          </ThemeProvider>
        </>
      )}
    </>
  );
}

export default App;
